import { Component, Input, OnInit } from '@angular/core';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EmployeeService } from '../../../../employee.service';
import { CovidService } from '../../../../services/covid.service';
import { LocalDataSource } from 'ng2-smart-table';
import * as moment from 'moment';
import { StationService } from '../../../../services/stations.service';

@Component({
  selector: 'ngx-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss'],
})
export class TestComponent implements OnInit {
  @Input() stationId: string;
  riskGroups = ['Mayor de 60 años de edad, Estado de embarazo o puerperio inmediato', 'Hipertensión arterial', 'Diabetes melitus', 'Enfermedad cardiaca o pulmonar crónica', 'Inmunosupresión (adquirida o provocada)', 'Insuficiencia renal o hepática'];
  symptoms = ['Fiebre', 'Cansancio', 'Tos seca', 'Dolores y molestías', 'Congestión nasal', 'Abundante secreción nasal', 'Dolor de garganta', 'Diarrea'];
  loading: boolean = false;
  services = ['Luz', 'Agua', 'Teléfono'];
  formSubmitted = false;
  formSubmittedPositive = false;
  employees = [];
  typeRegister = '';
  testForm: FormGroup;
  testPositiveForm: FormGroup;
  idSelectedEmployee = '';
  showEditTest = false;
  eventToEdit: any;

  constructor(
    private employeeService: EmployeeService,
    private formBuilder: FormBuilder,
    private covidService: CovidService,
    private stationService: StationService
  ) {
    this.stationService.change.subscribe(async (station: any) => {
      this.stationId = station;
      this.init();
    });
  }

  async ngOnInit() {
    this.init();
  }

  async init() {
    this.testForm = this.formBuilder.group({
      dangerPopulation: ['', [Validators.required]],
      contactWithPositiveCases: ['', [Validators.required]],
      travel: ['', [Validators.required]],
      symptom: ['', [Validators.required]],
      dateSymptoms: [''],
    });
    this.testPositiveForm = this.formBuilder.group({
      dateDetection: ['', [Validators.required]],
    });
    await this.getEmployeeStation();
    await this.getTestsByStationId();
  }

  source: LocalDataSource;
  settings = {
    actions: {
      columnTitle: 'Acciones',
      position: 'right',
      add: false,
      edit: false,
      delete: false,
      custom: [
        {
          name: 'edit',
          title: '<img src="assets/images/icons/edit.png" width="25px">',
        },
        {
          name: 'delete',
          title: '<img src="assets/images/icons/delete.png" width="25px">',
        },
      ],
    },
    pager: {
      perPage: 10,
    },
    columns: {
      name: {
        title: 'Nombre',
        filter: true,
      },
      dateCreated: {
        title: 'Fecha de creación',
        filter: true,
      },
      dateSymptoms: {
        title: 'Fecha inicio síntomas',
        filter: true,
      },
      role: {
        title: 'Puesto',
        filter: true,
      },
    },
  };

  async getEmployeeStation() {
    this.loading = true;
    const [err, response] = await this.employeeService.getEmployees(this.stationId);
    this.loading = false;
    if (err) return this.alert('Oops', 'error', 'Ocurrio un error al cargar la información, intenta más tarde por favor');
    this.employees = response.data;
  }

  get dangerPopulation() {
    return this.testForm.get('dangerPopulation');
  }

  get contactWithPositiveCases() {
    return this.testForm.get('contactWithPositiveCases');
  }

  get travel() {
    return this.testForm.get('travel');
  }

  get symptom() {
    return this.testForm.get('symptom');
  }

  get dateSymptoms() {
    return this.testForm.get('dateSymptoms');
  }

  get test() {
    return {
      dangerPopulation: this.dangerPopulation.value,
      contactWithPositiveCases: this.contactWithPositiveCases.value,
      travel: this.travel.value,
      symptom: this.symptom.value,
      dateSymptoms: this.dateSymptoms.value,
    };
  }

  get dateDetection() {
    return this.testPositiveForm.get('dateDetection');
  }

  get testPositive() {
    return {
      dateDetection: this.dateDetection.value,
    };
  }

  select(arr: any, val: any) {
    const i = arr.indexOf(val);
    if (i !== -1) arr.splice(i, 1);
    else arr.push(val);
  }

  async getTestsByStationId() {
    this.loading = true;
    const [err, response]: any = await this.covidService.getTestsByStationId(this.stationId);
    this.loading = false;
    if (err) return this.alert('Oops', 'error', 'Ocurrio un error al cargar la información, intenta más tarde por favor');
    const employees: any = {};
    const dataFormatted = [];
    for await(const employee of this.employees) employees[employee.id] = { name: employee.name, role: employee.role };
    for await (const test of response.data) {
      if (employees[test.employeeId]) {
        dataFormatted.push({
          ...test,
          name: employees[test.employeeId].name,
          role: employees[test.employeeId].role,
          dateSymptoms: (test.dateSymptoms) ? moment(test.dateSymptoms).format('ll') : '',
          dateCreated: moment.unix(test.created_at._seconds).format('ll'),
        });
      }
    }
    this.source = new LocalDataSource(dataFormatted);
  }

  async save() {
    this.formSubmitted = true;
    if (this.testForm.invalid) return 0;
    this.loading = true;
    const [err] = await this.covidService.store(this.stationId, this.idSelectedEmployee, this.test);
    this.loading = false;
    if (err) return this.alert('Oops', 'error', 'Ocurrio un error al intentar guardar la información, intenta más tarde por favor');
    this.testForm.reset();
    this.formSubmitted = false;
    await this.getTestsByStationId();
    return this.alert('Éxito', 'success', 'Test guardado con éxito');
  }

  async savePositive() {
    this.formSubmittedPositive = true;
    if (this.testPositiveForm.invalid) return 0;
    this.loading = true;
    const [err] = await this.covidService.storeCovidDetection(this.stationId, this.idSelectedEmployee, this.testPositive);
    this.loading = false;
    if (err) return this.alert('Oops', 'error', 'Ocurrio un error al intentar guardar la información, intenta más tarde por favor');
    this.testForm.reset();
    this.formSubmitted = false;
    return this.alert('Éxito', 'success', 'Caso positivo guardado con éxito');
  }

  async alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    await Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

  async edit() {
    this.formSubmitted = true;
    if (this.testForm.invalid) return 0;
    this.loading = true;
    const [err] = await this.covidService.update(this.test, this.eventToEdit.id);
    this.loading = false;
    if (err) return this.alert('Oops', 'error', 'Ocurrio un error al intentar guardar la información, intenta más tarde por favor');
    this.eventToEdit = 0;
    this.formSubmitted = false;
    await this.getTestsByStationId();
    this.alert('Éxito', 'success', 'Test actualizado con éxito');
    this.showEditTest = false;
    this.testForm.reset();
  }

  cancelEdit() {
    this.testForm.reset();
    this.showEditTest = false;
    this.eventToEdit = 0;
  }

  async deleteTest(id) {
    Swal.fire({
      title: '¿Estás seguro de eliminar?',
      text: 'Esta acción no se puede revertir',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Borrar',
    }).then(async (result) => {
      if (result.value) {
        const [error] = await this.covidService.delete(id);
        // tslint:disable-next-line: max-line-length
        if (error) return this.alert('Ocurrio un error al intentar borrar el elemento, intenta más tarde por favor', 'error');
        await this.getTestsByStationId();
        await this.alert('Test borrado con éxito');
      }
    });
  }

  onCustom(event: any) {
    if (event.action === 'delete') {
      this.deleteTest(event.data.id);
    } else if (event.action === 'edit') {
      this.eventToEdit = event.data;
      this.testForm.setValue({
        dangerPopulation: event.data.dangerPopulation,
        contactWithPositiveCases: event.data.contactWithPositiveCases,
        travel: event.data.travel,
        symptom: event.data.symptom,
        dateSymptoms: (event.data.dateSymtoms) ? new Date(moment(event.data.dateSymptoms, 'll').format('YYYY/MM/DD')) : '',
      });
      this.showEditTest = true;
    }
  }
}
